import SalePlanTemplate from "@/pages/salePlanTemplate/index.tsx";

const BusinessPlanTemp = () => {
  return <SalePlanTemplate templateType={'CLUE'}/>
}

export default BusinessPlanTemp